export const en = {
    'success-change': 'Product updated successfully'
};
